import FileLoader from '../../model/loader/file-loader'

export class DocumentImagePreprocessor {

  /**
   *
   * @param documentDefinition
   * @param rowData
   * @param callback
   * @returns {Promise<string>}
   */
  static preprocess (documentDefinition, rowData, callback) {
    let columnName = documentDefinition.ColumnName,
        fileGUID   = documentDefinition.FileGUID,
        id         = rowData[columnName],
        guid       = rowData[fileGUID]

    FileLoader
      .fileGUID(guid)
      .sizeType('S')
      .quality(30)
      .get(id)
      .then((response) => {
        let src = 'data:image/jpeg;base64,' +
          response.data.fileContents

        callback(src)
      })
  }
}
